import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import { Button } from "./Button";

function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener("resize", showButton);

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
            TRVL <i className="fab fa-typo3" />
          </Link>
          <div className="menu-icon" onClick={handleClick}>
            <i className={click ? "fas fa-times" : "fas fa-bars"} />
          </div>
          <ul className={click ? "nav-menu active" : "nav-menu"}>
            <li className="nav-item">
              <Link
                to="/france"
                className="nav-links"
                onClick={closeMobileMenu}
              >
                France
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/spain" className="nav-links" onClick={closeMobileMenu}>
                Spain
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/itlay" className="nav-links" onClick={closeMobileMenu}>
                Italy
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/tickets"
                className="nav-links"
                onClick={closeMobileMenu}
              >
                Tickets
              </Link>
            </li>
          </ul>
          {button && <Button buttonStyle="btn--outline">Go Adventuring</Button>}
        </div>
      </nav>
    </>
  );
}

export default Navbar;
